import { onMounted, onUnmounted } from 'vue'

/**
 * Composable to handle dynamic viewport height that accounts for mobile browser UI
 * Sets CSS custom properties for accurate viewport calculations
 */
export function useViewportHeight() {
    const setViewportHeight = () => {
    // Get the actual viewport height
        const vh = window.innerHeight * 0.01
        // Set the custom property
        document.documentElement.style.setProperty('--vh', `${vh}px`)
    
        // Also set dynamic viewport height units for modern browsers
        if (CSS.supports('height', '100dvh')) {
            document.documentElement.style.setProperty('--dynamic-vh', '1dvh')
        } else {
            document.documentElement.style.setProperty('--dynamic-vh', `${vh}px`)
        }
    }

    onMounted(() => {
    // Set on mount
        setViewportHeight()
    
        // Update on resize and orientation change
        window.addEventListener('resize', setViewportHeight)
        window.addEventListener('orientationchange', setViewportHeight)
    
        // Handle mobile browser address bar hide/show
        if (typeof window.visualViewport !== 'undefined') {
            window.visualViewport.addEventListener('resize', setViewportHeight)
        }
    })

    onUnmounted(() => {
        window.removeEventListener('resize', setViewportHeight)
        window.removeEventListener('orientationchange', setViewportHeight)
    
        if (typeof window.visualViewport !== 'undefined') {
            window.visualViewport.removeEventListener('resize', setViewportHeight)
        }
    })

    return {
        setViewportHeight
    }
}